import { createFileRoute } from "@tanstack/react-router";
import { loadContentMeta, buildContentHead } from "@/lib/seo/contentHead";
import WebinarPost from "@/pages/WebinarPost";

export const Route = createFileRoute("/en/webinars/$slug")({
  loader: ({ params }) => loadContentMeta("webinars", params.slug, "en"),
  head: ({ params, loaderData }) =>
    buildContentHead(`/en/webinars/${params.slug}`, loaderData),
  component: WebinarPost,
});

